import { Alert, AlertTitle, Box, TextField } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import { CONFIRM_TITLE } from "../../util/constants";
import ConfirmButton from "./ConfirmButton";
import SlideUpTransition from "./SlideUpTransition";

const useStyles = makeStyles((theme) => ({
  confirmationWarning: {
    width: "80%",
    margin: "auto",
  },
  commentBox: {
    width: "80%",
    margin: "10px auto",
  },
}));

const ConfirmationDialog = (props) => {
  const classes = useStyles();

  const handleCommentsChange = (comments) => {
    props?.setCommentsError(false);
    props?.setCommentErrorMessage("");
    props.setComments(comments.target.value);
  };
  return (
    <Dialog
      PaperProps={{
        sx: {
          width: "500px",
          maxWidth: "90vw",
          margin: "auto",
          whiteSpace: "pre-line",
        },
      }}
      open={props.isDialogOpen}
      TransitionComponent={SlideUpTransition}
      keepMounted
      data-testid="confirmation-dialog"
    >
      <DialogTitle id="alert-dialog-slide-title">{!!props.title ? props.title : CONFIRM_TITLE}</DialogTitle>
      <DialogContent>
        <DialogContentText component={"div"} id="alert-dialog-slide-description">
          <Grid container>
            <Grid item xs={12}>
              {props.message.__html ? <span dangerouslySetInnerHTML={props.message} /> : props.message}
            </Grid>
          </Grid>
        </DialogContentText>
      </DialogContent>
      {!!props?.hasInfo && <Alert severity="info">{props.infoMessage}</Alert>}
      {!!props.hasWarning && (
        <Alert severity="warning" className={!!props.warningTitle ? classes.confirmationWarning : undefined}>
          {!!props.warningTitle && (
            <AlertTitle>
              <strong>{props.warningTitle}</strong>
            </AlertTitle>
          )}
          {props.warningMessage}
        </Alert>
      )}
      {!!props.hasComments && (
        <>
          <TextField
            className={classes.commentBox}
            value={props.comments}
            variant="outlined"
            onChange={handleCommentsChange}
            label="Comments (Mandatory)"
            multiline
            error={props.commentsError}
            helperText={props.commentErrorMessage}
          />

          {props.comments.length > props.commentCharLimit ? (
            <Box sx={{ textAlign: "right", color: "primary.swaRed", width: "90%" }}>
              {props.comments.length} / {props.commentCharLimit}
            </Box>
          ) : (
            <Box sx={{ textAlign: "right", width: "90%" }}>
              {props.comments.length} / {props.commentCharLimit}
            </Box>
          )}
        </>
      )}
      <DialogActions>
        <ConfirmButton variant="outlined" color="primary" onClick={props.handleNoButtonClicked}>
          {props.noTitle ? props.noTitle : "No"}
        </ConfirmButton>
        {!!props.redirectTo ? (
          <Link to={props.redirectTo} className="link">
            <ConfirmButton variant="contained" color="primary" onClick={props.handleYesButtonClicked}>
              {props.yesTitle ? props.yesTitle : "Yes"}
            </ConfirmButton>
          </Link>
        ) : (
          <ConfirmButton
            variant="contained"
            color="primary"
            onClick={props.handleYesButtonClicked}
            isLoading={props.isYesLoading}
          >
            {props.yesTitle ? props.yesTitle : "Yes"}
          </ConfirmButton>
        )}
      </DialogActions>
    </Dialog>
  );
};

ConfirmationDialog.propTypes = {
  isDialogOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  handleNoButtonClicked: PropTypes.func,
  handleYesButtonClicked: PropTypes.func,
  redirectTo: PropTypes.string,
  isYesLoading: PropTypes.bool,
  hasWarning: PropTypes.bool,
  warningMessage: PropTypes.string,
  hasComments: PropTypes.bool,
  comments: PropTypes.string,
  setComments: PropTypes.func,
  commentsError: PropTypes.bool,
  setCommentsError: PropTypes.func,
  commentErrorMessage: PropTypes.string,
  setCommentErrorMessage: PropTypes.func,
  commentCharLimit: PropTypes.number,
  infoMessage: PropTypes.string,
  hasInfo: PropTypes.bool,
  warningTitle: PropTypes.string,
  yesTitle: PropTypes.string,
  noTitle: PropTypes.string,
};

export default ConfirmationDialog;
